// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ScrollToTop from './components/ScrollToTop';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import ErrorBoundary from './components/ErrorBoundary';
import ModalContainer from 'react-modal-promise';
// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ErrorBoundary>
          <ModalContainer />
          <ScrollToTop />
          <Router />
        </ErrorBoundary>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
